import axios from "./axios";
import { CreateVoucherDto, UpdateVoucherDto } from "pages/voucher-management/VoucherType";

export const createVoucher = async (voucher: CreateVoucherDto) => {
  const response = await axios.post("/voucher", voucher);
  return response.data;
};

export const updateVoucher = async (voucher: UpdateVoucherDto) => {
  const response = await axios.put(`/voucher/${voucher.id}`, voucher);
  return response.data;
};

export const getVouchers = async (page: number, pageSize: number, search: string) => {
  const response = await axios.get("/voucher", {
    params: {
      page: page,
      pageSize,
      search,
    },
  });
  return response.data;
};

export const getPrivateVoucherOptions = async () => {
  const response = await axios.get("/voucher/private/options");
  return response.data;
};

export const getVoucherByQRCode = async (qrCode: string) => {
  const response = await axios.get(`/voucher/qr-code?code=${qrCode}`);
  return response.data;
};

export const patchUseVoucher = async (voucherCode: string) => {
  const response = await axios.patch(`/voucher/qr-code/${voucherCode}`);
  return response.data;
};